(() => {
  'use strict';
  if (window.wcFontLibraryReady) return;
  window.wcFontLibraryReady = true;
  const load = (root) => {
    const markers = root.matches?.('template[data-wc-font]') ? [root] : [];
    markers.push(...(root.querySelectorAll?.('template[data-wc-font]') || []));
    for (const marker of markers) {
      const font = marker.dataset.wcFont;
      if (!['nstc', 'nrtc'].includes(font)) continue;
      const id = `wc-font-stylesheet-${font}`;
      if (document.getElementById(id)) continue;
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = marker.dataset.stylesheet;
      document.head.appendChild(link);
    }
  };
  load(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) load(node);
      }
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
